import React from 'react';

export class DailyReportUtil {
  static gcLabel(generalContractor) {
    return (
      <span>
        00 - General Contractor - <b>{generalContractor.name}</b>
      </span>
    );
  }

  static tradeLabel(projectContributor) {
    return (
      <span>
        {projectContributor.csi_code.division} -{' '}
        {projectContributor.csi_code.label} -{' '}
        <b>{projectContributor.company.name}</b>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/services/utils/daily-report-util.js